<template>
  <div class="full-height">
    <div
      :class="{
        simpleButtons: rowButtons,
        crudButtons: !rowButtons,
        cleanLayout: cleanLayout,
      }"
      class="row container q-px-sm"
    >
      <div class="fit">
        <q-card class="q-px-sm card-crud">

          <q-toolbar class="bg-white  shadow-2 rounded-borders ">
            <q-tabs v-model="tabsConfig.tabSelected" dense
          class="text-grey"
          active-color="primary"
          align="justify"
          indicator-color="red-10"
          narrow-indicator @click="updateGeneratorFixedOrderComponent">
              <q-tab :name="tabsConfig.tabOptions.tab1" :label="tabsConfig.tabsNames.orderByTicket" />
              <q-tab :name="tabsConfig.tabOptions.tab2" :label="tabsConfig.tabsNames.orderByContract" />
              <q-tab :name="tabsConfig.tabOptions.tab3" :label="tabsConfig.tabsNames.billingContractMaintenance" />
              <q-tab :name="tabsConfig.tabOptions.tab4" :label="tabsConfig.tabsNames.ordersByMovimantation" />
            </q-tabs>
          </q-toolbar>

          <q-card-section id="scroll-table" class="q-pb-lg card-table" v-if="tabsConfig.tabSelected == tabsConfig.tabOptions.tab1">
            <jt-data-table
              v-if="nmInterface && datatable && tabsConfig.tabSelected == tabsConfig.tabOptions.tab1"
              ref="jtDataTable"
              class="table-crud"
              :forms="forms"
              :buttons="datatable ? datatable.buttons : []"
              :fields="datatable.columns"
              :extra-params="extraParam"
              :default-http-options="defaultHttpOptions"
              :nm-interface="nmInterface"
              multiselect
              selectionForce
              :row-buttons="rowButtons"
              :selection-force="selectionForce"
              :columnEdit="columnEdit"
              :is-paginated="false"
              @action-button="actionButton"
              @show-message="showMessage"
              @selection="selection"
              @click-row="
                (row) => {
                  $emit('click-row', row);
                }
              "
            />
            <div id="subtitleOrders">
              <div id="totalGenerate" class="marginDefault">
                <span> {{ $gettext("TOTAL_GENERATE") }}:&nbsp;</span>
                <span class="formatedValue">
                  R$ {{ totalPriceFormatted }}
                </span>
              </div>
            </div>
          </q-card-section>
          <generator-fixed-order @on-change-table-data="countTotalByContract" :key="fixedOrderKey" ref="fixedOrder" v-bind="prefixedBillingOrderContentTable" v-if="tabsConfig.tabSelected == tabsConfig.tabOptions.tab2" />
          <generator-fixed-order @on-change-table-data="countTotalBillingContractMaintenance" :key="contractMaintenancefixedOrderKey" ref="contractMaintenancefixedOrder" v-bind="prefixedBillingOrderContentTable" searchType="contractMaintenance" v-if="tabsConfig.tabSelected == tabsConfig.tabOptions.tab3" />
          <industrial-movimatation @on-change-table-data="countTotalOrdersByMovimantation" v-bind="prefixedBillingOrderContentTable" v-if="tabsConfig.tabSelected == tabsConfig.tabOptions.tab4"/>
        </q-card>
      </div>
    </div>
    <generator-order-page-search-items-modal
      ref="generatorOrderPageSearchItemsModal"
    />
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import GeneratorOrderPageSearchItemsModal from './generator-order-page-search-items/GeneratorOrderPageSearchItemsModal.vue'
import { repository } from 'jtech'
const { pageTable } = JtCrud
import { QIcon } from 'quasar'
import GeneratorOrderEvent from './GeneratorOrderEvent'
import GeneratorFixedOrder from './preFixedBillingOrder/GeneratorFixedOrder.vue'
import IndustrialMovimatation from './industrial-movimantation/IndustrialMovimatation.vue'
import tabsConfigJs from './TabsConfig'
@Component({
  name: 'GenaratorOrderPageSearchTable',
  components: {
    GeneratorOrderPageSearchItemsModal,
    QIcon,
    GeneratorFixedOrder,
    IndustrialMovimatation
  },
  props: {
    itemsSelection: Array
  },
  mixins: [
    pageTable
  ]
})
class GenaratorOrderPageSearchTable extends Vue {
  totalPrice = 0;
  totalSelectedPrice = 0;
  prefixedBillingOrderContentTable = {}
  fixedOrderKey = 0
  contractMaintenancefixedOrderKey = 0
  tabsConfig = tabsConfigJs

  async updateGeneratorFixedOrderComponent () {
    this.prefixedBillingOrderContentTable = JSON.parse(JSON.stringify(this.$props))
    this.prefixedBillingOrderContentTable.datatable = await repository.resolveDatatable('preFixedBillingOrder.pesquisar', this.$props.params.controlBatch)
    this.fixedOrderKey += 1
    this.contractMaintenancefixedOrderKey += 1
  }

  async mounted () {
    this.updateGeneratorFixedOrderComponent()
    await this.countTotalOrdersByTabs()
    await this.updateTotalPrice()
    GeneratorOrderEvent.$on('refresh-page', () => this.refreshAllPage())
  }

  async countTotalOrdersByTabs () {
    this.countTotalByTicket(this.$props.params.totalByTicket)
    this.countTotalByContract(this.$props.params.totalByContract)
    this.countTotalBillingContractMaintenance(this.$props.params.totalContractMaintenance)
    this.countTotalOrdersByMovimantation(this.$props.params.totalPreBillingOrder)
  }

  countTotalOrdersByMovimantation (total) {
    this.tabsConfig.tabsNames.ordersByMovimantation = this.$gettextInterpolate(this.$gettext('ORDERS_BY_INDUSTRIAL_MOVIMATATION'), { total })
  }

  countTotalByContract (total) {
    this.tabsConfig.tabsNames.orderByContract = this.$gettextInterpolate(this.$gettext('ORDERS_BY_CONTRACT'), { total })
  }

  countTotalByTicket (total) {
    this.tabsConfig.tabsNames.orderByTicket = this.$gettextInterpolate(this.$gettext('ORDERS_BY_TICKET'),
      { total: total })
  }

  countTotalBillingContractMaintenance (quantity) {
    this.tabsConfig.tabsNames.billingContractMaintenance = this.$gettextInterpolate(this.$gettext('ORDERS_BY_BILLING_CONTRACT_MAINTENANCE'),
      { total: quantity | 0 })
  }

  async refreshAllPage () {
    const totalOfRowsGenerated = this.$refs.jtDataTable.extraParams.itemsSelection.length
    const totalOfRowsBefore = this?.$refs?.jtDataTable?.$refs?.tableRef?._data.serverData.length
    const newTotalOfRows = totalOfRowsBefore - totalOfRowsGenerated
    delete this.$refs.jtDataTable.extraParams.itemsSelection
    this.countTotalByTicket(newTotalOfRows)
    await this.updateTotalPrice()
    this.$refs.jtDataTable.refresh()
  }

  columnEdit ({ col, props }) {
    if (col.model == 'idBillingOrderToGroup') {
      if (props.row.idBillingOrderToGroup) {
        return `<div style="width:100%; height:22px;" class="visible" title="Pode ser agrupado">
         <span class="material-icons" style="font-size: 20px; color: red;">report_problem</span>
        </div>`
      }
    }
    return col.htmlProcessed
  }

  get totalPriceFormatted () {
    return Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(this.totalPrice)
  }

  get totalSelectedPriceFormatted () {
    return Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(this.totalSelectedPrice)
  }

  selection () {
    this.params.itemsSelection = this.$refs.jtDataTable.selected
  }

  actionButton (button, params) {
    if (button.name == 'btGenerateOrder') {
      this.$emit('action-button', button, this.$refs.jtDataTable.selected)
    } else if (button.name == 'icDetalhar') {
      this.$nextTick(() => {
        this.$refs.generatorOrderPageSearchItemsModal.show(params)
      })
    } else {
      this.$emit('action-button', button, params)
    }
  }

  async updateTotalPrice () {
    const { totalPrice } = await repository.resolveLogic('controlBatchTicket.getControlBatchTicketsPriceSum',
      { controlBatchIds: this.params.controlBatch })
    this.totalPrice = totalPrice
  }
}
export default GenaratorOrderPageSearchTable
</script>

<style lang='stylus'>
@import '~quasar-variables';
#subtitleOrders {
  height: 45px;
  display: flex;
  align-items: center;

  .marginDefault {
    margin: 0px 10px;
  }

  .formatedValue {
    font-weight: 500;
  }

  .visible {
    height: 3em;
    width: 10em;
    background: yellow;
  }

}
#scroll-table {
  .q-table__middle {
    height: 60vh
  }

  .table_header thead tr:first-child th {
    font-size: 0.85em
  }

  .q-table tbody td {
    max-width: 50px;
    font-size: 10px;
    padding: 4px 4px !important;
  }

  .q-table tbody tr td:nth-child(n+3):nth-child(-n+4) {
    white-space: normal
  }

}
</style>
